import { createContext, useReducer, useState, useEffect, memo } from 'react';
import { useMutation } from '@apollo/client';
import { GET_USER_PROFILE } from '../mutations/userMutations';

export const AuthContext = createContext()

export const authReducer = (state, action) => {
  switch (action.type) {
    case 'LOGIN':
      return {
        ...state,
        token: action.payload.token,
        isAdmin: action.payload.role === 'ADMIN' ? true : false
      }
    case 'LOGOUT':
      return {
        authUser: null,
        token: null,
        isAdmin: false,
        users: []
      }
    case 'GET_ME':
      return {
        ...state,
        authUser: action.payload
      }
    case 'UPDATE_USER':
      return {
        ...state,
        authUser: action.payload
      }
    /*case 'GET_USERS':
      return {
        ...state,
        users: action.payload
      }
    case 'DELETE_USER':
      return {
        ...state,
        users: state.users.filter((user) => user._id !== action.payload._id)
      }*/
    default:
      return state
  }
}

export const AuthContextProvider = memo(({ children }) => {
  const [isLoading, setIsLoading] = useState(true)

  const [state, dispatch] = useReducer(authReducer, {
    users: [],
    token: null,
    userId: '',
    authUser: null,
    isAdmin: false
  })

  // create an useMutation getUserProfile
  const [getUserProfile] = useMutation(GET_USER_PROFILE)

  const refetchUserProfile = async (id) => {
    try {
      const { data } = await getUserProfile({ variables: { id } })
      
      if (data && data.userProfile) {
        dispatch({ type: 'GET_ME', payload: data.userProfile })
      }
    } catch (error) {
      console.error("Error fetching user profile:", error)
      // Handle error (e.g., logout user, display error message)
    }
  };

  useEffect(() => {
    const fetchUser = async () => {
      const storedUserId = localStorage.getItem('authUser')

      if (storedUserId) {
        await refetchUserProfile(storedUserId) // Use refetchUserProfile to handle updates 
      }

      setIsLoading(false)
    }

    fetchUser()
  }, [])


  return (
    <AuthContext.Provider value={{ ...state, refetchUserProfile, isLoading, dispatch }}>
      { children }
    </AuthContext.Provider>
  )
})
